"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
const axios_class_1 = require("./axios.class");
const index_1 = require("./index");
class Messages {
    getProductMessages(productId, perPage = 10, currentPage = 0) {
        return axios_class_1.axios.get((0, index_1.buildURL)(`/v1/messages/${productId}`, {
            perPage,
            currentPage
        }));
    }
    getUnseenMessagesCountByCollection() {
        return axios_class_1.axios.get(`/v1/messages/unseenCountByNftCollections`);
    }
    getUnseenMessagesCountByProduct(collectionId) {
        return axios_class_1.axios.get(`/v1/messages/unseenCountByProducts/${collectionId}`);
    }
    /* returns last message body + count unread messages */
    async getLastUnreadMessage(perPage = 100, currentPage = 0) {
        const { data } = await axios_class_1.axios.get((0, index_1.buildURL)('/v1/messages/unseen', { currentPage, perPage }));
        return data;
    }
    /* get messaging page messages list */
    async getMessages({ perPage = 10, page = 0, signal }) {
        const { data } = await axios_class_1.axios.get((0, index_1.buildURL)(`/v1/messages/home`, { perPage, currentPage: page }), { signal });
        return data;
    }
    async getMessagesClient({ perPage = 10, page = 0, signal }) {
        const { data } = await axios_class_1.axios.get((0, index_1.buildURL)(`/v1/messages/client`, { perPage, currentPage: page }), { signal });
        return data;
    }
    /* Get collection messages before a given date (last messages if no date is given) */
    async getCollectionMessages({ collectionId, perPage = 10, currentPage = 0 }) {
        const { data } = await axios_class_1.axios.get((0, index_1.buildURL)(`v1/messages/collection/${collectionId}`, { perPage, currentPage }));
        return data;
    }
    /* mark messages as seen */
    async updateSeenMessages(messageIds) {
        const { data } = await axios_class_1.axios.post(`v1/messages/seen`, {
            messageIds
        });
        return data;
    }
    /**
    * url of message clicked
    */
    async urlClicked(messageId) {
        return axios_class_1.axios.patch(`/v1/messages/urlClicked/${messageId}`);
    }
    async sendClientCommunication(communicationData) {
        return await axios_class_1.axios.post(`v1/messages/sendClientCommunication`, communicationData);
    }
    /**
    * create communication
    */
    async createClientCommunication(communicationData) {
        return await axios_class_1.axios.post(`v1/messages/communication`, communicationData);
    }
    /**
    * get communication
    */
    async getCommunications({ perPage = 1000, page = 0 }) {
        const { data } = await axios_class_1.axios.get((0, index_1.buildURL)(`/v1/messages/communications`, { perPage, currentPage: page }));
        return data;
    }
    /**
    * update space
    */
    async updateCommunication(communicationId, communication) {
        return axios_class_1.axios.patch(`/v1/messages/communications/${communicationId}`, communication);
    }
    /**
    * update space
    */
    async deleteCommunication(communicationId) {
        return axios_class_1.axios.delete(`/v1/messages/communications/${communicationId}`);
    }
}
exports.messages = new Messages();
